<template>
    <section id="vue-rsvp">
        <rsvp-form />
    </section>
</template>

<script>
import RSVPForm from '../components/rsvp-form.vue';

export default {
    name: 'rsvp-view',
    components: {
        'rsvp-form': RSVPForm
    },
    data: () => ({})
};
</script>


// WEBPACK FOOTER //
// src/views/rsvp.vue?96c38fcc